import {store} from '../store/store.js';

export let AdobeAnalytics = {
  loadIfConfigured() {
    if (!this.isEnabled()) {
      return Promise.resolve();
    }
    return Promise.all([
      this.downloadScript(store.state.config.origin + '/plugins/adobe-heartbeat/VisitorAPI.js').then(() => {
        console.log(store.state.config)
        // eslint-disable-next-line no-undef
        Visitor.getInstance(store.state.config.adobeMarketingCloudOrganizationId, {
          trackingServer: store.state.config.adobeTrackingDomain
        });
      }),
      this.downloadScript(store.state.config.origin + '/plugins/adobe-heartbeat/AppMeasurement.js').then(() => {
        var sAccount = store.state.config.adobeReportSuiteId;
        // eslint-disable-next-line no-undef
        var s = s_gi(sAccount);
        // Make sure data is sent to the correct location
        s.trackingServer = store.state.config.adobeTrackingDomain;
        // eslint-disable-next-line no-undef
        s.visitor = Visitor.getInstance(store.state.config.adobeMarketingCloudOrganizationId);
        window.s = s;
      }),
      this.downloadScript(store.state.config.origin + '/plugins/adobe-heartbeat/VideoHeartbeat.min.js')
    ]).then(() => {
      this.setUp();
    });
  },
  isEnabled() {
    return store.getters.isAdobeAnalyticsEnabled;
  },
  downloadScript(scriptUrl) {
    return new Promise((resolve, reject) => {
      var script;
      script = window.document.createElement('script');
      script.type = 'text/javascript';
      script.src = scriptUrl;
      script.onload = script.onreadystatechange = () => {
        resolve();
      };
      script.onerror = (error) => {
        reject(error);
      }
      window.document.head.appendChild(script);
    });
  },
  setUp() {

  }
}
